"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCard = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledCard = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbox-shadow: ", ";\n\tborder-radius: ", "px;\n\t", ";\n\t", ";\n\t", "\n"])), function (props) {
  return props.withShadow ? '0 3px 6px 0 rgba(0, 0, 0, 0.16)' : '';
}, function (props) {
  return props.theme.borderRadii.medium;
}, (0, _styledSystem.variant)({
  prop: 'variant',
  scale: 'backgrounds'
}), _styledSystem.space, _styledSystem.layout);
exports.StyledCard = StyledCard;